import type { UnitReport } from '../../../shared/domain/reports/types.no-deps'
import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'

export const route: Route = { method: 'GET', pattern: '/api/units/:unitId/reports' }

export const sortFields = ['most-recent', 'last-activity'] as const
export type SortField = (typeof sortFields)[number]

type Params = { unitId: number }
type Body = never
type Query = {
    submittedBefore?: Date
    limit?: number
    offset?: number

    // TODO: Unit Reports V2
    // sortField?: SortField
    // childUnitIds?: number[]
    includeDescendants?: boolean
    statusIds?: number | number[]
    workflowIds?: number | number[]
}
type Output = {
    reports: UnitReport[]
    limit: number
    offset: number
    count: number
}

export type GetReportsEndpoint = Endpoint<Params, Body, Query, Output>

export const getReportsRequest = (request: Request, args: RequestArgs<GetReportsEndpoint>) =>
    request<GetReportsEndpoint>(route, args)
